<template>
    <div id="supportPage" :class="'popupPage anim'+ ( open ? ' open' : '' )">
        <div v-if="open" class="container d-flex flex-column">
            <div class="row align-strach">
                <div class="col-md-6 h-100 m-auto text-center d-flex flex-column">
                    <div class="header mb-3">
                        <h3 class="m-auto">{{ $t('support.popup_title') }}</h3>
                        <a @click.prevent="open = false;btnSfx();" href="#" class="close"></a>
                    </div>
                    <div class="d-flex justify-content-center mb-4">
                        <img src="/images/bg-support.png" style="height: 12vh;"/>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="open" class="chat-list-holder">
            <div v-if="loading" class="d-flex h-100">
                <div class="m-auto text-center">
                    <h5 class="mb-5">{{ $t('base.loading') }}</h5>
                </div>
            </div>
            <div v-else-if="messages.length == 0" class="d-flex h-100">
                <div class="m-auto text-center">
                    <img src="/images/icon-support.png" class="vh-10 mb-3"/>
                    <h5 class="mb-2">{{ $t('support.popup_no_messages') }}</h5>
                </div>
            </div>
            <div v-else class="container d-flex flex-column">
                <div class="row align-strach">
                    <div class="col-md-6 h-100 m-auto text-center d-flex flex-column">
                        <ul class="chat-list">
                            <li v-for="m in messages" :key="m.id" :class="{ 'chat-item--my' : !m.officialResponse, 'animate__animated animate__zoomIn animate__faster' : animateId == m.id }">
                                <div class="chat-item__image">
                                    <img :src="!m.officialResponse && user.avatarUrl != undefined ? user.avatarUrl : '/images/male-default.png'" class="profileImage"/>
                                </div>
                                <div class="chat-item__content">
                                    <div v-if="m.officialResponse" class="text-primary small">
                                        <b>AdBalu</b>
                                    </div>
                                    <p>{{ m.text }}</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <form v-if="showTextInput" @submit.prevent="sendMessage">
            <div class="container">
                <div class="row">
                    <div class="col-md-6 m-auto">
                        <b-input-group class="py-3">
                            <b-form-input v-model="text" maxlength="500"></b-form-input>
                            <b-input-group-append>
                                <b-button type="submit" @click="btnSfx()" variant="primary"><i class="fas fa-paper-plane"></i></b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import Vue from 'vue'

import api from '../../api'


const SupportPopup = Vue.component('support-popup', {
    data() {
        return {
            loading: false,
            open: false,
            messages: [],
            animateId: undefined,
            text: "",
            showTextInput: false
        }
    },
    computed: {
        user() {
            return this.$store.state.auth.user;
        }
    },
    methods:{
        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },
        
        show() {
            this.open = true;
            this.loading = true;
            this.text = "";

            this.loadMessages();
        },
        
        hide() {
            this.loading = false;
            this.open = false;
        }, 

        sendMessage(){
            if(this.text.trim() === "") return;

            const $this = this;
            let loader = document.getElementById('loader');
            loader.classList.add("show");

            api.supportMessagesSend(this.text.trim())
            .then(res => {
                $this.text = "";
                $this.showTextInput = false;
                loader.classList.remove("show");
                $this.onMessage(res.data, true);
            })
            .catch(err => {
                api.baseErrorHendler(err);
            })
            .then(() => {
                loader.classList.remove("show");
            });
        },

        onMessage(data){
            if(this.messages.find(x => x.id == data.id)) 
                return;

            // add message to list
            this.messages.push(data);
            this.animateId = data.id;
            this.$store.dispatch('sound/sfx','Message');

            var list = document.querySelector("#supportPage .chat-list-holder");
            if(list != undefined && (data.user.id == this.user.id || (list.scrollTop + list.clientHeight + 40) >= list.scrollHeight))
                this.scrollToEnd();
        },
        
        scrollToEnd(){
            this.$nextTick(() => {
                var list = document.querySelector("#supportPage .chat-list-holder");
                if(list != undefined) 
                    list.scrollTop = list.scrollHeight;
            });
        },

        loadMessages(){
            const $this = this;
            this.messages = [];
            this.animateId = undefined;
            this.loading = true;

            api.supportMessages()
            .then(res => {
                $this.loading = false;
                $this.messages = res.data.reverse();
                $this.showTextInput = $this.messages.length == 0 || $this.messages[$this.messages.length - 1].officialResponse;
                $this.scrollToEnd();
            })
            .catch(err => {
                $this.loading = false;
                api.baseErrorHendler(err);
            });
        },
        
    },
    watch: {
        open(){
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            document.body.scrollTop = 0; // For Safari
            if(this.open) document.body.classList.add("lock");
            else document.body.classList.remove("lock");
        },
    }
})

export default SupportPopup
</script>